<template>
  <tr>
    <template v-for="(field, idx) in fields">
      <Cell
        :key="idx"
        :item="item"
        :field="field"
        :onClickRow="onClickRow"
        @reloadTable="reloadTable"
      ></Cell>
    </template>
  </tr>
</template>

<script>
import Cell from "./DataViewerCell";

export default {
  name: "data-viewer-item",
  components: {
    Cell,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    onClickRow: Function,
  },
  methods: {
    reloadTable() {
      this.$emit("reloadTable");
    },
  },
};
</script>